module.exports = __webpack_public_path__ + "static/media/login-back-user-mobile.92b9db56.jpg";